import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useHttpClient } from "@/core/http/HttpClientContext";
import { SocialPlatform, SocialProfile } from "@/types";
import { portalSocialProfilesService } from "../services/portalSocialProfilesService";

const key = (clientId: string) => ["portal", "social-profiles", clientId] as const;

export function usePortalSocialProfiles(clientId: string) {
  const http = useHttpClient();
  return useQuery({
    queryKey: key(clientId),
    queryFn: () => portalSocialProfilesService.get(http),
  });
}

/** Saves one platform and writes the server's answer straight into the cache. */
export function useUpdatePortalSocialProfile(clientId: string) {
  const http = useHttpClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ platform, profile }: { platform: SocialPlatform; profile: SocialProfile }) =>
      portalSocialProfilesService.update(http, platform, profile),
    onSuccess: (data) => queryClient.setQueryData(key(clientId), data),
  });
}
